<!--home 主页-->
<template>
    <div class="home">
        <header class="header">
            <oa-nav></oa-nav>
        </header>
        <div class="main">
            <div class="content">
                <router-view></router-view>
            </div>
        </div>
        <footer class="footer">
            <p></p>
            <p>法律服务在线互动&nbsp;&nbsp;&nbsp;&nbsp;网站备案序号：苏ICP备 07010100 号</p>
            <p>江苏省工商业联合会 江苏省总商会 地址：南京建邺路168号10号楼 邮编：210004 传真：025-83329618 联系我们</p>
        </footer>
    </div>
</template>

<script>
import oaNav from "./oaNav/oaNav";
export default {
    name: "home",
    components: {
        oaNav
    },
    data() {
        return {};
    },
    methods: {}
};
</script>

<style lang="less" scoped="scoped">
.home {
}
</style>